import React, { useState } from "react";
import "./Menu.css";

const Menu = () => {
  const [activeCategory, setActiveCategory] = useState("appetizers");

  const menuData = {
    appetizers: [
      {
        name: "Samosa (2 pieces)",
        description:
          "Crispy triangular pastries with spiced filling, served with chutney",
        price: "$5.95",
      },
      {
        name: "Vegetable Pakora",
        description:
          "Fresh vegetables dipped in spiced gram flour batter and deep fried to perfection",
        price: "$6.95",
      },
      {
        name: "Crispy Pakora",
        description:
          "A crispy fusion of fresh filling in spiced gram flour batter. Perfectly fried and served with chutney",
        price: "Veg: $7.95 | Chicken: $8.95 | Paneer: $8.95",
      },
      {
        name: "Paneer",
        description: "Fresh cottage cheese cooked in aromatic spices",
        price: "Vegetarian or Chicken: $7.95",
      },
      {
        name: "Momo (8 pieces)",
        description:
          "These mouthwatering dumplings are stuffed with a delectable mixture of fresh vegetables or chicken and aromatic spices",
        price: "Veg: $9.99 | Chicken: $10.99",
      },
      {
        name: "Chaat",
        description:
          "Crispy samosas or pakoras crumbled and topped with tangy chutneys, yogurt, and fresh garnishes",
        price: "Samosa Chaat: $7.95 | Pakora Chaat: $6.95",
      },
      {
        name: "Chicken 65",
        description:
          "Spicy marinated chicken fired to perfection. Served with tangy lemon wedges",
        price: "$9.95",
      },
      {
        name: "Masala Wings",
        description:
          "Chef secret spicy marinated chicken perfection of cooking wings with mouthwatering taste",
        price: "$9.95",
      },
      {
        name: "Medium Fries",
        description: "Crispy golden french fries",
        price: "$2.95",
      },
      {
        name: "Chicken Tenders (4 pieces)",
        description: "Breaded and fried chicken tenders",
        price: "$5.95",
      },
      {
        name: "Naan Bread",
        description:
          "Soft, oven-baked bread: perfect for dipping, wrapping, or savoring solo",
        price: "Butter: $2.95 | Garlic: $3.95",
      },
      {
        name: "Basmati Rice",
        description: "Fragrant long-grain rice served in a bowl",
        price: "Basmati: $1.29 | Jeera: $1.49",
      },
    ],
    mainCourse: [
      {
        name: "Chicken Curry",
        description:
          "Tender chicken cooked in a rich and flavorful sauce with aromatic spices, onions, and tomatoes",
        price: "$13.95",
      },
      {
        name: "Chicken Tikka Masala",
        description:
          "Tender pieces of grilled chicken cooked in a creamy tomato-based sauce infused with aromatic spices",
        price: "$14.95",
      },
      {
        name: "Biryani",
        description:
          "Fragrant basmati rice cooked with tender marinated chicken, infused with aromatic spices, and garnished with fried onions and fresh herbs",
        price: "Veg: $12.95 | Chicken: $13.95 | Lamb: $14.95",
      },
      {
        name: "Lamb Curry",
        description:
          "Juicy lamb pieces marinated and cooked in a rich, tomato-based sauce, bursting with spices, offer a flavorful journey for your taste buds",
        price: "Vegetarian, Chicken, or Lamb: $13.95",
      },
      {
        name: "Chicken Chili",
        description:
          "Tender chicken stir-fried with vibrant bell peppers, onions, and aromatic spices, providing a tantalizing blend of heat and flavor",
        price: "$13.95",
      },
      {
        name: "Butter Chicken",
        description:
          "Tender chicken cooked in a creamy tomato-based sauce infused with aromatic spices",
        price: "$13.95",
      },
      {
        name: "Gobi Manchurian",
        description:
          "Cauliflower stir-fried with vibrant bell peppers, onions, and aromatic spices, offering a tantalizing blend of heat and flavor",
        price: "$13.95",
      },
      {
        name: "Noodles (Nepali Style Chowmein)",
        description: "Stir-fried noodles with Nepali spices and choice of meat",
        price: "Veg: $11.95 | Chicken: $12.95 | Lamb: $13.95",
      },
    ],
    beverages: [
      {
        name: "Lassi",
        description:
          "Lassi is a traditional Indian yogurt-based beverage, available in sweet and savory varieties",
        price: "Mango/Sweet/Salt: $2.99",
      },
      {
        name: "Soda",
        description: "Choose from Coke, Sprite, Pepsi, or Dr Pepper",
        price: "$1.59",
      },
      {
        name: "Nepali Style Tea",
        description: "Traditional spiced tea",
        price: "$1.99",
      },
    ],
  };

  const categories = [
    { key: "appetizers", label: "Appetizers" },
    { key: "mainCourse", label: "Main Course" },
    { key: "beverages", label: "Beverages" },
  ];

  return (
    <section id="menu" className="menu">
      <div className="container">
        <h2>Our Menu</h2>
        <div className="menu-categories">
          {categories.map((category) => (
            <button
              key={category.key}
              className={`menu-category ${
                activeCategory === category.key ? "active" : ""
              }`}
              onClick={() => setActiveCategory(category.key)}
            >
              {category.label}
            </button>
          ))}
        </div>

        <div className="menu-grid">
          {menuData[activeCategory].map((item, index) => (
            <div key={index} className="menu-item">
              <div className="item-info">
                <h3>{item.name}</h3>
                <p>{item.description}</p>
              </div>
              <div className="item-price">{item.price}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Menu;
